import React, { useState, useEffect, useCallback } from 'react'
import i18n from 'i18n/index.js'

function MyGallery(props){
  const [images, setImages] = useState([]);
  const [isLightboxOpen, setIsLightboxOpen] = useState(false);
  const [activeImageIndex, setActiveImageIndex] = useState(0);

  const thumbs = images.length > 1 ? images.slice(1, 5) : [];
  const thumbCount = thumbs.length;

  useEffect(() => {
      setImages(props.excursion_images || []);
  }, [props.excursion_images]);

  const closeLightbox = useCallback(() => {
    setIsLightboxOpen(false);
  }, []);

  const openLightbox = useCallback((index) => {
    setActiveImageIndex(index);
    setIsLightboxOpen(true);
  }, []);

  const goPrev = useCallback(() => {
    setActiveImageIndex((i) =>
      images.length ? (i - 1 + images.length) % images.length : 0
    );
  }, [images.length]);

  const goNext = useCallback(() => {
    setActiveImageIndex((i) =>
      images.length ? (i + 1) % images.length : 0
    );
  }, [images.length]);

  useEffect(() => {
    if (!isLightboxOpen) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') goPrev();
      if (e.key === 'ArrowRight') goNext();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [isLightboxOpen, closeLightbox, goPrev, goNext]);

  useEffect(() => {
    if (!isLightboxOpen) return undefined;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, [isLightboxOpen]);

  const layoutClass =
    thumbCount === 0
      ? "my-gallery__layout my-gallery__layout--hero-only"
      : "my-gallery__layout my-gallery__layout--with-thumbs";

  const activeImage = images[activeImageIndex];

  return (
    <section className="my-gallery-section">
      { images.length > 0 ? (
        <div className="single-slider product-photo-gallery my-gallery">
          <div className="single-slider-gallery">
            <div className={layoutClass}>
              <div className="my-gallery__hero">
                <a
                  href={images[0].original_url}
                  className="my-gallery__hero-link"
                  onClick={(e) => { e.preventDefault(); openLightbox(0); }}
                >
                  <img
                    className="my-gallery__hero-img skeleton"
                    src={images[0].original_url}
                    alt={images[0].alt || images[0].custom_alt}
                    width={images[0].image_width}
                    height={images[0].image_height}
                    decoding="async"
                  />
                </a>
              </div>
              {thumbCount > 0 && (
                <div
                  className={`my-gallery__thumbs my-gallery__thumbs--count-${thumbCount} hidden-md-down`}
                >
                  {thumbs.map((image, index) => (
                    <div key={image.id || index} className="my-gallery__thumb-cell">
                      <a
                        href={image.original_url}
                        className="my-gallery__thumb-link"
                        onClick={(e) => { e.preventDefault(); openLightbox(index + 1); }}
                      >
                        <img
                          className="my-gallery__thumb-img skeleton"
                          src={image.large_url}
                          alt={image.alt || image.custom_alt}
                          width={image.image_width}
                          height={image.image_height}
                          loading="lazy"
                          decoding="async"
                        />
                      </a>
                    </div>
                  ))}
                </div>
              )}
            </div>
            <button type="button" className="btn btn-images-slideshow" onClick={() => openLightbox(0)}>
              {i18n.t('products_show_photos', { n: images.length })}
            </button>
          </div>
          {isLightboxOpen && activeImage && (
            <div className="oi-lightbox" role="dialog" aria-modal="true" aria-label={i18n.t('products_show_photos', { n: images.length })}>
              <div className="oi-lightbox__backdrop" onClick={closeLightbox} aria-hidden="true" />
              <div className="oi-lightbox__stage">
                <img
                  className="oi-lightbox__image"
                  src={activeImage.original_url}
                  alt={activeImage.alt || activeImage.custom_alt || ''}
                  draggable={false}
                />
              </div>
              <button type="button" className="oi-lightbox__button oi-lightbox__close" onClick={closeLightbox} aria-label="Cerrar">
                ×
              </button>
              {images.length > 1 && (
                <>
                  <button type="button" className="oi-lightbox__button oi-lightbox__prev" onClick={goPrev} aria-label="Foto anterior" />
                  <button type="button" className="oi-lightbox__button oi-lightbox__next" onClick={goNext} aria-label="Foto siguiente" />
                </>
              )}
            </div>
          )}
        </div>
      ) : (
        <section id="photos-loader">
          <div className="single-slider-gallery my-gallery my-gallery--skeleton">
            <div className="my-gallery__layout my-gallery__layout--with-thumbs">
              <div className="my-gallery__hero">
                <div
                  className="my-gallery__skeleton-hero oi-skeleton oi-skeleton--wave oi-skeleton--rounded oi-w-full"
                  aria-hidden
                />
              </div>
              <div className="my-gallery__thumbs my-gallery__thumbs--count-4 hidden-md-down">
                <div className="my-gallery__skeleton-thumb oi-skeleton oi-skeleton--wave oi-skeleton--rounded oi-w-full" aria-hidden />
                <div className="my-gallery__skeleton-thumb oi-skeleton oi-skeleton--wave oi-skeleton--rounded oi-w-full" aria-hidden />
                <div className="my-gallery__skeleton-thumb oi-skeleton oi-skeleton--wave oi-skeleton--rounded oi-w-full" aria-hidden />
                <div className="my-gallery__skeleton-thumb oi-skeleton oi-skeleton--wave oi-skeleton--rounded oi-w-full" aria-hidden />
              </div>
            </div>
          </div>
        </section>
      )}
    </section>
  );
}

export default MyGallery
